module.exports = __webpack_public_path__ + "fc53b3b72bd604079c282a478d1e6d1e.pdf";